module.exports = __webpack_public_path__ + "static/media/badInteriorPackaging.f37c457a.png";